/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1681
 */

var r = require(/* 1086 */"./1086")
var o = require(/* 400 */"../1648/400")
var i = require(/* 1682 */"./1682")
if (!r) {
  o(Object.prototype, "toString", i, {
    unsafe: true
  })
}
